
import Vue from 'vue'
const eventHub = new Vue()
Vue.mixin({
  data: function () {
    return {
      eventHub: eventHub
    }
  }
})



// WEBPACK FOOTER //
// ./src/mixins/eventHub/index.js